export default "__VITE_ASSET__BKhQd7zt__"